import React from 'react';
import { useTranslation } from 'react-i18next';
import { PageContainer } from '../../../modules/page-container/page-container';
import { FocusFrame } from '../../../visual-components/focus-frame/focus-frame';
import { useKeyVisual } from '../hooks/use-key-visual';
import { PopularSeries } from './popular-series';
import { SearchSection } from './search-section';
import { LastVisitedArticles } from './last-visited-articles';

export const HomeLoggedIn: React.FC = () => {
  const { t } = useTranslation();

  const imageUrl = useKeyVisual();

  return (
    <PageContainer
      documentTitle={t('home.documentTitle')}
      pageHeader={{
        type: 'base',
        content: <FocusFrame text={t('home.pageTitle')} />,
        imgUrl: imageUrl,
      }}
    >
      <SearchSection />
      <PopularSeries />
      <LastVisitedArticles />
    </PageContainer>
  );
};
